import { render } from "./WorkflowTypeChip.vue?vue&type=template&id=1be007a1&scoped=true"
import script from "./WorkflowTypeChip.vue?vue&type=script&lang=js"
export * from "./WorkflowTypeChip.vue?vue&type=script&lang=js"

import "./WorkflowTypeChip.vue?vue&type=style&index=0&id=1be007a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be007a1"]])

export default __exports__